/**
 * PREFILL - The status for successfully prefilling the LMJ form
 * ERROR - The status for failing fetch and prefill the LMJ form.
 * OUT_OF_RANGE - The status for when the user tried to create an LMJ but it's too late (must be at least 4 hours from the current time)
 * based on the prefill data start time.
 */

export enum PrefillLmjInfoFromSessionBannerStatus {
  PREFILL = 'prefill',
  ERROR = 'error',
  OUT_OF_RANGE = 'out-of-range',
}
